import axiosCommon from '@/axios-common/axios-common';
import InfiniteLoading from 'vue-infinite-loading';
import vSelect from 'vue-select';

export default {
    name: 'fieldStoryDashboard',
    dependencies:['localeService'],
    components: {
        InfiniteLoading,
        vSelect
    },
    mounted() {
        this.initialize()
    },
    data() {
        return {
            fieldStories: [],
            search: {
                months: '',
                years: '',
                keywords: ''
            },
            months: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
            ],
            years: [],
            skip: 0,
            take: 5
        }
    },
    methods: {
        initialize() {
            let vm = this;

            vm.initializeYears();

            return vm.getFieldStories()
                .then(function (res) {
                    if (res.data.length > 0) {
                        vm.fieldStories = res.data;
                    }
                })
                .catch(function (err) {
                    console.log(err);
                    return err;
                });
        },
        initializeYears() {
            let vm = this;
            let now = new Date();
            for (let year = now.getFullYear() ; year >= 1900 ; year--) {
                vm.years.push(String(year));
            }
        },
        infiniteHandler($state) {
            let vm = this;
            vm.skip += vm.take;
            vm.getFieldStories()
                .then(function (res) {
                    vm.fieldStories = vm.fieldStories.concat(res.data);
                    $state.loaded();
                    if (res.data.length == 0) {
                        $state.complete()
                    }
                })
                .catch(function (err) {
                    console.log(err);
                    return err;
                });

        },
        filter() {
            let vm = this;
            vm.skip = 0;
            vm.take = 0;
            vm.getFieldStories()
                .then(function (res) {
                    vm.fieldStories = res.data;
                })
                .catch(function (err) {
                    console.log(err);
                    return err;
                });
        },
        getFieldStories() {
            let vm = this;
            return axiosCommon.get(`o/fieldStories?language=${vm.localeService.getCurrentLocale()}&skip=${vm.skip}&take=${vm.take}&months=${vm.search.months.toString()}&years=${vm.search.years.toString()}&keywords=${vm.search.keywords}`)
                .then(function (res) {
                    return res;
                })
                .catch(function (err) {
                    return err;
                });
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/field-story-dashboard/field-story-dashboard.js